<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group" style="align-items: center;">
    <div class="form-group col-md-6">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="estados" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="''" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="listEstados"
          [label]="'Estado'" formControlName="estados" [control]="estados.get('estados')" [id]="'estados'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>Generar</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>

<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Tipo de Liquidación'" [label]="'Tipo de Liquidación *'" [id]="'tipoLiquidacion'"
          formControlName="tipoLiquidacion" [control]="formulario.get('tipoLiquidacion')"></app-lfsa-input>
      </div>
      <div>
        <hr>
      </div>
      <div *ngIf="isCreate || estadoCierre != 'CERRADO'">
        <div>
          Unidades de Negocio:
        </div>
        <br><br>
        <div class="d-flex flex-wrap">
          <div class="px-3 py-1" *ngFor="let unidad of unidadesDeNegocio">
            <input type="checkbox" name="unidadDeNegocio[]" [value]="unidad.idUnidad"
              id="unidadDeNegocio{{ unidad.idUnidad }}" (change)="unidadDeNegocioChange(null)">
            <label for="unidadDeNegocio{{ unidad.idUnidad }}">
              {{ unidad.descCorta }}
            </label>
          </div>
        </div>
        <div>
          <hr>
        </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Proceso - Liquidación'" [label]="'Proceso - Liquidación *'" [id]="'idLiquidacion'"
          formControlName="idLiquidacion" [control]="formulario.get('idLiquidacion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <div *ngIf="isCreate || estadoCierre != 'CERRADO'">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbMeses" formControlName="mes" [control]="formulario.get('mes')" [label]="'Mes *'"
            [id]="'mes'">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!(isCreate || estadoCierre != 'CERRADO')">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Mes'"
            [label]="'Mes *'" [id]="'mesDescripcion'" formControlName="mesDescripcion"
            [control]="formulario.get('mesDescripcion')"></app-lfsa-input>
        </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="!(isCreate || estadoCierre != 'CERRADO')" [type]="'number'"
          [class]="'letrasDanger'" [placeholder]="'Año'" [label]="'Año *'" [id]="'anio'" formControlName="anio"
          [control]="formulario.get('anio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Usuario de Carga'"
          [label]="'Usuario de Carga *'" [id]="'usuario'" formControlName="usuario"
          [control]="formulario.get('usuario')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <div *ngIf="isCreate || estadoCierre != 'CERRADO'">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
            [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
            [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!(isCreate || estadoCierre != 'CERRADO')">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
            [placeholder]="'Tipo de Vendedor'" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorDescripcion'"
            formControlName="tipoVendedorDescripcion"
            [control]="formulario.get('tipoVendedorDescripcion')"></app-lfsa-input>
        </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <div *ngIf="isCreate || estadoCierre != 'CERRADO'">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreAMostrar'" [idOpcion]="'idVendedor'"
            [comboBox]="listVendedores" formControlName="vendedorId" [control]="formulario.get('vendedorId')"
            [label]="'Vendedor *'" [id]="'vendedorId'">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!(isCreate || estadoCierre != 'CERRADO')">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Vendedor'"
            [label]="'Vendedor *'" [id]="'nombreVendedor'" formControlName="nombreVendedor"
            [control]="formulario.get('nombreVendedor')"></app-lfsa-input>
        </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <div *ngIf="isCreate || estadoCierre != 'CERRADO'">
          <app-lfsa-input
            [isReadOnly]="(formulario.get('vendedorId').value !== 'todos' && formulario.get('vendedorId').value !== null && formulario.get('vendedorId').value !== undefined) && (formulario.get('anio').value === null || formulario.get('anio').value == '') && (formulario.get('mes').value === null || formulario.get('mes').value == '') ? false : true"
            [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Fecha Inicio'" [label]="'Fecha Inicio *'"
            [id]="'fechaInicio'" formControlName="fechaInicio"
            [control]="formulario.get('fechaInicio')"></app-lfsa-input>
          <div
            *ngIf="fechaInicioError && (formulario.get('anio').value === null || formulario.get('anio').value == '') && (formulario.get('mes').value === null || formulario.get('mes').value == '')"
            class="letrasDanger">
            Fecha Inicio no puede ser menor al mes actual.
          </div>
          <div
            *ngIf="(formulario.get('fechaInicio').value > formulario.get('fechaFin').value) && (formulario.get('anio').value === null || formulario.get('anio').value == '') && (formulario.get('mes').value === null || formulario.get('mes').value == '')"
            class="letrasDanger">
            Fecha Inicio no puede ser mayor a Fecha Fin.
          </div>
        </div>
        <div *ngIf="!(isCreate || estadoCierre != 'CERRADO')">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Fecha Inicio'"
            [label]="'Fecha Inicio *'" [id]="'fechaInicio'" formControlName="fechaInicio"
            [control]="formulario.get('fechaInicio')"></app-lfsa-input>
        </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <div *ngIf="isCreate || estadoCierre != 'CERRADO'">
          <app-lfsa-input
            [isReadOnly]="(formulario.get('vendedorId').value !== 'todos' && formulario.get('vendedorId').value !== null && formulario.get('vendedorId').value !== undefined) && (formulario.get('anio').value === null || formulario.get('anio').value == '') && (formulario.get('mes').value === null || formulario.get('mes').value == '') ? false : true"
            [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Fecha Fin'" [label]="'Fecha Fin *'"
            [id]="'fechaFin'" formControlName="fechaFin" [control]="formulario.get('fechaFin')"></app-lfsa-input>
          <div
            *ngIf="fechaFinError && (formulario.get('anio').value === null || formulario.get('anio').value == '') && (formulario.get('mes').value === null || formulario.get('mes').value == '')"
            class="letrasDanger">
            Fecha Fin no puede ser mayor al mes actual.
          </div>
          <div
            *ngIf="(formulario.get('fechaInicio').value > formulario.get('fechaFin').value) && (formulario.get('anio').value === null || formulario.get('anio').value == '') && (formulario.get('mes').value === null || formulario.get('mes').value == '')"
            class="letrasDanger">
            Fecha Fin no puede ser menor a Fecha Inicio.
          </div>
        </div>
        <div *ngIf="!(isCreate || estadoCierre != 'CERRADO')">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Fecha Fin'"
            [label]="'Fecha Fin *'" [id]="'fechaFin'" formControlName="fechaFin"
            [control]="formulario.get('fechaFin')"></app-lfsa-input>
        </div>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Estado Proceso'"
          [label]="'Estado Proceso *'" [id]="'estadoProceso'" formControlName="estadoProceso"
          [control]="formulario.get('estadoProceso')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Estado Cierre'"
          [label]="'Estado Cierre *'" [id]="'estadoCierre'" formControlName="estadoCierre"
          [control]="formulario.get('estadoCierre')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Total canales / Tipo Vendedor'" [label]="'Total canales / Tipo Vendedor *'"
          [id]="'totalTipoLiquida'" formControlName="totalTipoLiquida"
          [control]="formulario.get('totalTipoLiquida')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Total Empleados'"
          [label]="'Total Empleados *'" [id]="'totalEmplLiquida'" formControlName="totalEmplLiquida"
          [control]="formulario.get('totalEmplLiquida')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Total a Liquidar'" [label]="'Total a Liquidar *'" [id]="'totalPagoLiquida'"
          formControlName="totalPagoLiquida" [control]="formulario.get('totalPagoLiquida')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Fecha Procesamiento'" [label]="'Fecha Procesamiento *'" [id]="'fechaProceso'"
          formControlName="fechaProceso" [control]="formulario.get('fechaProceso')"></app-lfsa-input>
      </div>
      <br><br>
      <div class="form-group col-12 col-md-12">
        <div class="row">
          <div class="form-group col-12 col-md-2">
            <button class={{DAT_BTNCSS.danger}} (click)="limpiarRegresar()">Regresar</button>
          </div>
          <div class="form-group col-12 col-md-8"></div>
          <div class="form-group col-12 col-md-2">
            <button class={{DAT_BTNCSS.primary}} (click)="consultar()"
              *ngIf="isCreate || estadoCierre != 'CERRADO'">Procesar</button>
          </div>
          <!-- <div class="form-group col-12 col-md-2">
            <button class={{DAT_BTNCSS.success}} (click)="procesar()">Guardar</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario> -->
  </div>
</ng-template>

<app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

<app-lfsa-card [innTemplate]="detalleComosiones" [titulo]="'Detalle de Comisiones'" *ngIf="mostrarDetalle">
</app-lfsa-card>

<ng-template #detalleComosiones>
  <div [formGroup]="listFiltroTabla" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-2">
        <select class="form-control form-select" formControlName="listTipoFiltroTabla">
          <option *ngFor="let data of listTipoFiltroTabla" [value]="data.clave">{{ data.valor }}</option>
        </select>
      </div>
      <div class="form-group col-12 col-md-2"></div>
      <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="descargarLogs()">Logs</button>
      </div>
      <!-- <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="procesar()">Imprimir</button>
      </div> -->
      <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="descargarReporte()">Reporte</button>
      </div>
      <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="procesar()"
          *ngIf="isCreate || estadoCierre != 'CERRADO'">Guardar</button>
      </div>
      <div class="form-group col-12 col-md-2">
        <button class={{DAT_BTNCSS.success}} (click)="cerrar()"
          *ngIf="isCreate || estadoCierre != 'CERRADO'">Cerrar</button>
      </div>
      <hr class="mt-3 mb-3">
      <div class="form-group col-12" style="overflow: scroll;max-width: 100%;max-height: 500px;">
        <div class="w-100 text-center my-5" *ngIf="lsDetalle && lsDetalle.length == 0">
          No hay resultados para el filtro seleccionado.
        </div>
        <!-- <table *ngIf="listFiltroTabla.get('listTipoFiltroTabla').value == 'Todos'"> -->
        <table>
          <tbody>
            <tr *ngFor="let liquidacion of lsDetalle">
              <td>
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Tipo</th>
                      <th>Variable Asignada</th>
                      <th>Sueldo Base</th>
                      <th>Peso %</th>
                      <th>Valor Variable</th>
                      <th>Vendedor</th>
                      <th>% Cumplimiento</th>
                      <th>Venta</th>
                      <th>% Ganancia</th>
                      <th>Comisión</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let vendedor of liquidacion.listVendedoresLiquidacion"
                      [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }">
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }">{{liquidacion.indicadorVendedor}}
                      </td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }">{{vendedor.nombreTipoVendedor}}
                      </td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }">{{vendedor.nombreVariable}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.sueldoExcepcion > 0 ? vendedor.sueldoExcepcion :
                        vendedor.sueldoVariable}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.variablePeso}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.valorPeso}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }">{{vendedor.nombreVendedor}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.cumplimiento}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.valorVenta}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.ganancia}}</td>
                      <td [ngStyle]="{'color': vendedor.correct ? 'black' : 'red' }" align="center">
                        {{vendedor.valorComision}}</td>
                    </tr>
                  </tbody>
                  <!-- <tfoot *ngIf="listFiltroTabla.get('listTipoFiltroTabla').value == 'Todos'"> -->
                  <tfoot>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <!-- <td align="center">{{liquidacion.sueldoBase}}</td> -->
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td align="right" class="totalSticky"><b>TOTAL:</b></td>
                    <td align="center">{{liquidacion.comision}}</td>
                  </tfoot>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
